//src/components/shared/PermissionButton.tsx
import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { usePermissions } from "@/hooks/usePermission";

type ButtonProps = React.ComponentProps<typeof Button>;

type PermissionButtonProps = ButtonProps & {
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
  noPermissionLabel?: string;
};

export function PermissionButton({
  permission,
  permissions,
  requireAll = false,
  noPermissionLabel = "Seu perfil permite apenas consulta ou não possui permissão para esta ação",
  disabled,
  children,
  ...props
}: PermissionButtonProps) {
  const allowed = usePermissions(
    permission ? [permission, ...(permissions ?? [])] : permissions,
    { requireAll },
  );

  const finalDisabled = disabled || !allowed;
  const tooltipLabel = !allowed ? noPermissionLabel : undefined;

  const button = (
    <span className="inline-flex">
      <Button {...props} disabled={finalDisabled}>
        {children}
      </Button>
    </span>
  );

  if (!tooltipLabel) {
    return button;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent>
        <p>{tooltipLabel}</p>
      </TooltipContent>
    </Tooltip>
  );
}
